import styled, { css } from "styled-components/macro";

// The client app redesign's sheet: 8px from the screen on a phone, the whole column on a desktop
export const Sheet = styled.div`
  /* Legacy questions and descriptions inside keep their 16px phone size and spacing on every
     width, the size of the dashboard's rows, and set lists and inputs at 400 like the rest of
     the text */
  --juno-font-size-body-md: var(--juno-font-size-body-sm);
  --radio-line-height-md: var(--card-body-line-height);
  --juno-font-weight-light: var(--juno-font-weight-regular);
  display: flex;
  flex-direction: column;
  gap: var(--juno-space-4);
  margin-right: calc(-1 * var(--probate-card-inset, 0px));
  margin-left: calc(-1 * var(--probate-card-inset, 0px));
  padding: var(--juno-space-2) var(--juno-space-4) var(--juno-space-4);
  border-radius: var(--radius-3xl);
  background-color: var(--card);
  color: var(--card-foreground);
`;

// Puts the text 40px from the sheet's edge, 16px under the page's title and 32px above a tray,
// its paragraphs 8px apart however deeply a request's description nests them
export const SheetBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--juno-space-2);
  padding: 0 var(--juno-space-6) var(--juno-space-4);

  > *,
  p:last-child {
    margin: 0;
  }

  p {
    margin: 0 0 var(--juno-space-2);
  }
`;

// A message's HTML spaced as the Figma message frame 492:19892 ("Overview - Oct 14"): blocks 8px
// apart, a heading 40px under the section before and 32px above its own text, as the frame's
// 44px heading box around a 20px line gives
const messageSpacing = css`
  display: flex;
  flex-direction: column;
  gap: var(--juno-space-2);

  > p,
  > ul,
  > ol {
    margin: 0;
  }

  > ul,
  > ol {
    /* The frame's list text sits 1.5em in */
    padding-left: var(--juno-space-6);
  }

  > h2,
  > h3 {
    margin: var(--juno-space-8) 0 var(--juno-space-6);
    /* 18px: the frame's 16px headings over 13px text, scaled to the 16px body */
    font-size: 1.125rem;
    line-height: var(--card-body-line-height);
    font-weight: var(--juno-font-weight-regular);
  }

  > :first-child {
    margin-top: 0;
  }
`;

export const MessageText = styled.div`
  ${messageSpacing}
`;

export const MessageBody = styled(SheetBody)`
  ${messageSpacing}
  /* With the sheet's 16px, the last line sits 40px from the bottom, as it does from the sides */
  padding-bottom: var(--juno-space-6);
`;
